  <h2 mat-dialog-title class="mat-title">
    <span >{{'Add_User' | translate}}</span>
    <span class="close-dialog" (click)="cancel()">&#10006;</span>
  </h2>
  <mat-dialog-content>
    <p class="mat-body-2">{{'ADD_USER.search_user' | translate}}</p>
  <form>
    <mat-form-field class="example-chip-list" appearance="outline" floatLabel="always">
      <mat-label>{{ 'ADD_USER.search_user' | translate }}</mat-label>
      <input placeholder="{{ 'APP_USERS.search_user' | translate }}" #userInput [formControl]="userCtrl"
      (keyup)="resetUser()"
       [matAutocomplete]="auto" matInput
        #panel = "matAutocompleteTrigger"
        /> 
        <mat-icon matSuffix>search</mat-icon>
       
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        @if (_appUsersService.loading) {
        <app-spinner>
    </app-spinner>
        }
          @for (user of filteredUsers|async; track user) {
          <mat-option [value]="user">
            <div class="flex-row">
            <p class="mat-body-2">
              {{ user?.name }}  
            </p>
            <p class="mat-body-2">({{ user?.email }})</p>
            </div>

          </mat-option>
          }
      </mat-autocomplete>
      @if (userCtrl.errors) {
      <mat-error>
        {{'ADD_USER.search_error' | translate}}
      </mat-error>
      }
    </mat-form-field>
  </form>
  @if (selectedUser) {
  <div>
  @if (roles?.length > 0) {
  <p class="mat-body-2">{{'ADD_USER.select_roles' | translate}}</p>
  }
  @for (role of roles; track role) {
  <span class="role-row">
    <mat-checkbox color="primary" (change)="role.hasAccess = !role.hasAccess" (click)="$event.stopPropagation()" [checked] = "role.hasAccess">{{role?.name}}</mat-checkbox>
  </span>
  }
</div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-dialog-close (click)="cancel()">{{'APP_USERS.close' | translate}}</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true" (click)="saveUser()" [disabled]="!disableSave() || userCtrl.value.length<3 || !selectedUser">{{ 'APP_USERS.save' | translate }}</button>
</mat-dialog-actions>
